import React, { useContext } from 'react';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { Link } from 'react-router-dom';
import logComponent from '../../common/logComponent';

export default function CardLinkNotes() {
  const environmentContext = useContext(EnvironmentContext);
  const { activeUser: user, selectedUnit, selectedMonitoredIndividual } = environmentContext;
  if (logComponent('CardLinkNotes')) { console.debug('CardLinkNotes rendered'); }
  return (
    <div>
        {
          selectedMonitoredIndividual &&
          user.groupTypeString === 'Facility' ?
          <Link to={`/monitoredindividual/${selectedMonitoredIndividual.monitoredIndividualId}/notes`}>See full notes history</Link> :
          user.groupTypeString === 'Family' ?
            <Link to={`/notes`}>See full notes history</Link> :
            null
        }
        {
          selectedUnit &&
            <Link to={`/unit/${selectedUnit.unitId}/notes`}>See full notes history</Link>
      }
    </div>
    );
}
